import React, { useState } from "react";
import {
  Button,
  IconButton,
  Card,
  Popover,
  CardActions,
  CardContent,
  Typography,
  Tooltip,
} from "@mui/material";
import CopyAllIcon from "@mui/icons-material/CopyAll";
import useReferentiel from "hooks/useReferentiel";
// ----------------------------------------------------------------------
export default function RefsEditCloneBtn({ editData, refName, addLabel }) {
  const { cloneRefsubject, initRefs } = useReferentiel();
  const [submitting, setsubmitting] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleConfirm = async () => {
    try {
      if (!refName) return;
      setsubmitting(true);
      await cloneRefsubject(editData);
      await initRefs();
      setsubmitting(false);
      setAnchorEl(null);
    } catch (error) {
      console.error(error);
      setsubmitting(false);
    }
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <Tooltip title={addLabel}>
        <IconButton onClick={handleClick} color="warning">
          <CopyAllIcon />
        </IconButton>
      </Tooltip>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Card
          sx={{
            minWidth: 275,
          }}
        >
          <CardContent>
            <Typography
              sx={{ fontSize: 14 }}
              color="text.secondary"
              gutterBottom
            >
              Êtes vous sur de copier ?
            </Typography>
          </CardContent>
          <CardActions sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button disabled={submitting} onClick={handleConfirm}>
              Valider
            </Button>
            <Button onClick={handleClose}>Annuler</Button>
          </CardActions>
        </Card>
      </Popover>
    </div>
  );
}
